<template>
    <header class="bg-background">
        <!-- Mobile row 1: menu + logo + avatar -->
        <div class="flex items-center justify-between border-b border-border px-5 py-3 lg:hidden">
            <button
                type="button"
                class="-ml-2 flex size-10 items-center justify-center text-foreground transition-colors hover:text-foreground/80"
                aria-label="Open menu"
                @click="mobileMenuOpen = true"
            >
                <Menu class="size-5" />
            </button>

            <inertia-link href="/" class="flex items-center" aria-label="Home">
                <LogoFull class="h-5 w-auto" />
            </inertia-link>

            <TopbarAccountMenuV2 />
        </div>

        <!-- Desktop row 1: logo + team switch / notifications + invite + avatar -->
        <div class="hidden items-center justify-between border-b border-border px-8 py-2 lg:flex">
            <div class="flex items-center gap-10">
                <inertia-link href="/" class="flex items-center" aria-label="Home">
                    <LogoFull class="h-5 w-auto" />
                </inertia-link>
                <TopbarTeamSwitchV2 />
            </div>

            <div class="flex items-center gap-4">
                <TopbarNotificationsV2 variant="icon" />
                <Button
                    v-if="canInvite"
                    variant="outline"
                    size="sm"
                    @click="goToInvite"
                >
                    Invite
                </Button>
                <TopbarAccountMenuV2 />
            </div>
        </div>

        <!-- Row 2: primary navigation -->
        <TopbarNavV2 />
    </header>

    <TopbarMobileMenuV2
        :open="mobileMenuOpen"
        :can-invite="canInvite"
        @update:open="mobileMenuOpen = $event"
        @invite="goToInvite"
    />
</template>

<script lang="ts" setup>
import { Button } from '@/components/ui/button';
import { Menu } from 'lucide-vue-next';
import TopbarNavV2 from './components/v2/TopbarNavV2.vue';
import TopbarTeamSwitchV2 from './components/v2/TopbarTeamSwitchV2.vue';
import TopbarAccountMenuV2 from './components/v2/TopbarAccountMenuV2.vue';
import TopbarNotificationsV2 from './components/v2/TopbarNotificationsV2.vue';
import TopbarMobileMenuV2 from './components/v2/TopbarMobileMenuV2.vue';
import { ITopolPageProps } from '@/types/TopolPageProps/TopolPageProps';

const globalProps = computed(() => usePage<ITopolPageProps>().props);

const mobileMenuOpen = ref(false);

const canInvite = computed(() => {
    const role = globalProps.value.team_role?.key;
    return role === 'owner' || role === 'admin';
});

const goToInvite = () => {
    mobileMenuOpen.value = false;
    router.get(route('members.index'), { invite: 1 });
};

let removeNavigateListener: (() => void) | null = null;

onMounted(() => {
    removeNavigateListener = router.on('navigate', () => {
        mobileMenuOpen.value = false;
    });
});

onUnmounted(() => {
    removeNavigateListener?.();
});
</script>
